import { useEffect, useState } from "react";
import { Radio, Volume2 } from "lucide-react";

const PrerollSplash = ({ config, onEnter }) => {
  const [countdown, setCountdown] = useState(5);
  const pc = config?.primary_color || "#8B5CF6";
  const sc = config?.secondary_color || "#22C55E";

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="preroll-splash"
      style={{ background: "#050505" }}>
      <div className="absolute inset-0" style={{
        background: `radial-gradient(ellipse at 30% 30%, ${pc}40 0%, transparent 50%), radial-gradient(ellipse at 70% 70%, ${sc}30 0%, transparent 50%)`
      }} />
      <div className="relative z-10 text-center max-w-md px-6">
        {config?.logo_url ? (
          <img alt={config?.player_name || "Station"} className="w-36 h-36 mx-auto mb-6 object-contain"
            src={config.logo_url} style={{ filter: `drop-shadow(0 0 30px ${pc})` }} />
        ) : (
          <div className="w-36 h-36 mx-auto mb-6 rounded-full flex items-center justify-center"
            style={{ background: `linear-gradient(135deg, ${pc}, ${sc})`, boxShadow: `0 0 60px ${pc}60` }}>
            <Radio className="w-16 h-16 text-white" />
          </div>
        )}
        <p className="text-lg mb-6" style={{ color: "#A1A1AA" }}>
          {config?.tagline || "Live Radio"}
        </p>
        <div className="flex items-center justify-center gap-1 mb-8">
          {[24, 32, 40, 28, 36].map((h, i) => (
            <div key={`l-${i}`} className="w-1 rounded-full sound-bar"
              style={{ height: `${h}px`, background: `linear-gradient(to top, ${pc}, ${sc})`, animationDelay: `${i * 0.15}s` }} />
          ))}
          <Volume2 className="w-5 h-5 mx-2" style={{ color: pc }} />
          {[36, 28, 40, 32, 24].map((h, i) => (
            <div key={`r-${i}`} className="w-1 rounded-full sound-bar"
              style={{ height: `${h}px`, background: `linear-gradient(to top, ${pc}, ${sc})`, animationDelay: `${(i + 5) * 0.15}s` }} />
          ))}
        </div>
        <p className="text-sm mb-6" style={{ color: "#71717A" }}>
          Powered by our amazing sponsors
        </p>
        <button
          disabled={countdown > 0}
          onClick={onEnter}
          data-testid="preroll-enter"
          className="px-8 py-3 rounded-xl font-bold transition-all hover:scale-105 disabled:opacity-50"
          style={{ background: countdown > 0 ? "#27272a" : `linear-gradient(135deg, ${pc}, ${sc})`, color: "white" }}>
          {countdown > 0 ? `Starting in ${countdown}...` : "Enter Station"}
        </button>
        <p className="text-xs mt-4" style={{ color: "#71717A" }}>
          Donate to enjoy ad-free listening
        </p>
      </div>
      <style>{`
        .sound-bar { animation: soundBar 0.8s ease-in-out infinite alternate; }
        @keyframes soundBar { 0% { transform: scaleY(0.3); } 100% { transform: scaleY(1); } }
      `}</style>
    </div>
  );
};

export default PrerollSplash;
